module.exports = __webpack_public_path__ + "img/collapse-all.0015e44d.svg";